import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { OpenInNewIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { useReopenPetition } from './hooks/useReopenPetition';

export const ReopenPetition: React.FC = () => {
	const {
		actions: { handleReopenPetition },
	} = useReopenPetition();

	return (
		<>
			<Box mb={[8, 24]} mt={[8, 32]} pr={8} sx={{ flex: '100%' }}>
				<Translate value="corgi.petition.edit.settings.reopen_petition.description" />
			</Box>
			<Box mb={24} mr={48} mt={[0, 24]}>
				<Button
					onClick={handleReopenPetition}
					variant="primary"
					leadingIcon={<OpenInNewIcon />}
					data-qa="reopen-petition-button"
				>
					<Translate value="corgi.petition.edit.settings.reopen_petition.button" />
				</Button>
			</Box>
		</>
	);
};
